import { useSelector } from 'react-redux';
import { getGameTradesPrize } from '../selectors';

export const useGameTradesPrice = () => ({
  prize: useSelector(getGameTradesPrize),
});
